import BrowserStorage from '@module/browserstorage';

let featureTypesKey = 'featuresNotificationsData';
if (
  window['__feature_flags__'] &&
  window['__feature_flags__']['user'] &&
  window['__feature_flags__']['user']['key']
) {
  featureTypesKey += `_${window['__feature_flags__'] &&
    window['__feature_flags__']['user'] &&
    window['__feature_flags__']['user']['key']}`;
}

export default {
  panel: {},
  transfer: {},
  popover: {},
  features: {
    storage: {
      key: featureTypesKey,
      supported: BrowserStorage.isSupported,
    },
    data:
      (BrowserStorage.isSupported && BrowserStorage.getItem(featureTypesKey)) ||
      {},
  },
};
